import { Suspense, useContext, useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import './i18n'
import { initializeGoogleAnalytics } from '../lib/google_analytics'

import { CanonicalLink } from './canonical_link'
import { Footer } from './footer'
import { Header } from './header'
import { Modal } from './modal'
import { Router } from './router'

import '../stylesheets/Modal.scss'
import { AuthProvider, AuthContext } from '../contexts/auth_context'
import { BasketProvider } from '../contexts/basket_context'
import { SettingsProvider } from '../contexts/settings_context'
import { ErrorsProvider } from '../contexts/errors_context'
import { SearchProvider } from '../contexts/search_context'

// FIXME: This should probably be set in config
initializeGoogleAnalytics('UA-42912969-1')

const App = () => {
  const gitSha = process.env.REACT_APP_GIT_SHA ?? ''
  const { reloadCurrentUser } = useContext(AuthContext)

  useEffect(() => {
    if (reloadCurrentUser) {
      reloadCurrentUser().then(() => {})
    }
  }, [reloadCurrentUser])

  return (
    <AuthProvider>
      <SettingsProvider>
        <BasketProvider>
          <SearchProvider>
            <ErrorsProvider>
              <div className="App">
                <Suspense fallback="">
                  <BrowserRouter>
                    <CanonicalLink />
                    <Header />
                    <Router gitSha={ gitSha } />
                    <Footer />
                    <Modal />
                  </BrowserRouter>
                </Suspense>
              </div>
            </ErrorsProvider>
          </SearchProvider>
        </BasketProvider>
      </SettingsProvider>
    </AuthProvider>
  )
}

export { App }
